'use es6';

export const _formatSingleExperimentTreatment = treatment => {
  const paramsString = Object.keys(treatment.parameters).map(key => {
    const value = treatment.parameters[key];
    return `(${key}:${value})`;
  }).join('');
  return `${treatment.key}|${paramsString}`;
};
export const getFormattedExperimentArray = experimentReducerState => {
  if (!experimentReducerState || experimentReducerState.isLoading || experimentReducerState.hasErrors) {
    return [];
  }

  const treatments = experimentReducerState.treatments;
  return Object.keys(treatments).map(key => treatments[key]).map(_formatSingleExperimentTreatment).filter(t => {
    return Boolean(t);
  });
};